<template>
    <div class="table-responsive">
        <table class="table table-striped table-bordered text-center mb-0">
            <thead class="bg-grey">
                <tr>
                    <th>Order #</th>
                    <th>Delivery Date</th>
                    <th>PO #</th>
                    <th>Program</th>
                    <th>Status</th>
                </tr>
            </thead>
            <tbody v-if="processingOnlineOrdersCount > 0">
                <tr v-for="(order, index) in processingOnlineOrders" :key="index">
                    <td><a :href="`/account/processing-online-order-details/${order.id}`">{{ order.ns_tran_number }}</a></td>
                    <td>{{ order.delivery_date }}</td>
                    <td>{{ order.po }}</td>
                    <td>{{ order.program_code }}</td>
                    <td>{{ order.status_name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>
<script setup>
import { computed } from "vue";

const props = defineProps({
    processingOnlineOrders: {
        type: Array,
        default: () => []
    }
});
const processingOnlineOrdersCount = computed(() => props.processingOnlineOrders?.length ?? 0);
</script>